import { Controller, useFormContext } from 'react-hook-form';
import { InputBox } from '../../../../../../../components';
import Layout from '../../../Layout';
import styles from './SetupCampaignConfigurations.module.scss';

const { Section, Title, Subtitle, Option } = Layout;
const { RadioGroup, Radio, Error, FormDescription } = InputBox;

export const SetupCampaignConfigurations = () => {
  const form = useFormContext();
  return (
    <Section.Root className={styles.container}>
      <Section.Header>
        <Title>Configurações de campanhas</Title>
        <Subtitle className={styles.description}>Defina as configurações para a precificação de campanhas promocionais</Subtitle>
      </Section.Header>

      <div className={styles.divider} />

      <Section.Content>
        <Option.Root className={styles['option-root']}>
          <Option.Header>
            <Option.Title>priorização de campanhas</Option.Title>
            <Option.Subtitle>Defina como será priorizado o preço de campanha quando tiver mais de uma campanha vigente ao mesmo tempo</Option.Subtitle>
          </Option.Header>
          <Option.Content>
            <Controller
              control={form.control}
              name="campaignPrioritization"
              render={({ field: { value, onChange }, fieldState: { error } }) => {
                return (
                  <InputBox>
                    <RadioGroup value={value} onChange={onChange} className={styles['radio-group']} defaultValue={value || 'PRIORITY_TYPE'}>
                      <Radio className={styles['radio-description']} value="PRIORITY_TYPE">
                        <span>Considerar a priorização definida nos tipos de campanhas</span>
                        <FormDescription>
                          Será considerado sempre o grau de prioridade do tipo de campanha para definir qual preço oferta ficará ativo
                        </FormDescription>
                      </Radio>
                      <Radio className={styles['radio-description']} value="PRICE_LOWER">
                        <span>Considerar sempre o preço mais baixo</span>
                        <FormDescription>O preço de oferta que será usado deve ser sempre o preço mais baixo entre todas as campanhas vigentes</FormDescription>
                      </Radio>
                    </RadioGroup>
                    <Error message={error?.message} />
                  </InputBox>
                );
              }}
            />
          </Option.Content>
        </Option.Root>
      </Section.Content>

      <div className={styles.divider} />

      <Section.Content>
        <Option.Root className={styles['option-root']}>
          <Option.Header>
            <Option.Title>Edição de Ofertas em Campanha</Option.Title>
            <Option.Subtitle>Defina se as ofertas podem ser modificadas durante o período que a campanha está vigente</Option.Subtitle>
          </Option.Header>
          <Option.Content>
            <Controller
              control={form.control}
              name="campaignOfferEditing"
              render={({ field: { value, onChange }, fieldState: { error } }) => {
                return (
                  <InputBox>
                    <RadioGroup value={value} onChange={onChange} className={styles['radio-group']} defaultValue={value || 'ALLOW_EDITING'}>
                      <Radio className={styles['radio-description']} value="ALLOW_EDITING">
                        <span>Permitir a edição de ofertas durante a vigência da campanha</span>
                        <FormDescription>Será possível editar ou excluir uma oferta enquanto a campanha estiver vigente</FormDescription>
                      </Radio>
                      <Radio className={styles['radio-description']} value="DO_NOT_ALLOW_EDITING">
                        <span>Não permitir a edição de ofertas durante a vigência da campanha</span>
                        <FormDescription>Não será possível editar ou excluir uma oferta enquanto a campanha estiver vigente</FormDescription>
                      </Radio>
                    </RadioGroup>
                    <Error message={error?.message} />
                  </InputBox>
                );
              }}
            />
          </Option.Content>
        </Option.Root>
      </Section.Content>
    </Section.Root>
  );
};
